"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1650))
 * @lastsynced 2026-10-29T13:50:55.426Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Edit = createSVGIcon(
  <path
    d="M20.572 16.286v5.142a1.714 1.714 0 0 1-1.715 1.715H2.571a1.714 1.714 0 0 1-1.714-1.715V5.143a1.714 1.714 0 0 1 1.714-1.715h5.143m5.143 11.958-5.143.908.9-5.151 9.784-9.784a1.714 1.714 0 0 1 2.424 0l1.819 1.82a1.714 1.714 0 0 1 0 2.423z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Edit",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      id: "jlb8/p",
      defaultMessage: "Edit",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    color: iconColor.primary,
    className: iconCls(),
  })
);
